/**
 * Hook for loading entities index for search functionality
 * Uses TanStack Query for efficient data caching
 */

import { useQuery } from '@tanstack/react-query';
import { fetchEntitiesIndex } from '../../services/entities';

/**
 * Hook to get entities index for search functionality
 * @returns {Object} Query result with entities index data
 */
export const useEntitiesIndex = () => useQuery({
  queryKey: ['entities', 'index'],
  queryFn: fetchEntitiesIndex,
  staleTime: 1000 * 60 * 30, // 30 minutes
  gcTime: 1000 * 60 * 60 * 2, // 2 hours
  retry: 2,
});

export default useEntitiesIndex;
